<template>
    <div>
       <b-overlay :show="showoverlay" rounded="sm">
        <!-- alpha fix- added class border to table to show border in JV report -->
            <table class="table dataTable border">
                <thead>
                    <tr class="table-head">
                        <th v-for="report_column in reportColumns" :key="report_column.name"><span>{{report_column.label}}</span></th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="hover-bg table-row border-bottom mx-2" v-for="jvreport in jvreports" :key="jvreport.id">
                        <td>{{jvreport.gl_account_code}}</td>
                        <td>{{jvreport.gl_account_name}}</td>

                        <!-- alpha fix- added class text-right to debit and credit columns to align the values to right -->
                        <td class="text-right">{{jvreport.debit}}</td>
                        <td class="text-right">{{jvreport.credit}}</td>
                    </tr>
                    <tr>
                        <td></td>
                        <td></td>
                         <!-- alpha fix- added class text-right to debit and credit columns to align the values to right -->
                        <td class="text-right">{{total_dc.debit}}</td>
                        <td class="text-right">{{total_dc.credit}}</td>
                    </tr>
                </tbody>
            </table>
        </b-overlay>
    </div>
</template>
<script>
import VeeValidate from 'vee-validate';
    export default {
        name: 'JVReport',
        props:  [ 'payrun_id', 'total_dc' ],
    data() {
        let reportColumns = [
                {label: 'GL Account Code', name: 'gl_account_code' },
                {label: 'GL Account Name', name: 'gl_account_name'},
                {label: 'Debit', name: 'Debit'},
                {label: 'Credit', name: 'Credit'},
            ];
      return {
        reportColumns: reportColumns,
      }
    },
    created() {
        this.jvreports = this.payrun_id;
        this.total_dc = this.total_dc;
    },
  }
</script>
